/* eslint-disable */
import React from "react";
import { assetImages } from "constants";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ExistingTaskWarningModal = ({ taskId = null }) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const history = useHistory();

  const stopOngoingTaskHandler = () => {
    if (taskId) {
      //hide  modal
      let bootstrapModal = document.querySelector("#existingtaskwarning");
      let modal = bootstrap.Modal.getInstance(bootstrapModal);
      modal.hide();

      history.push(`/admin/task/details/${taskId}`);
    }
  };

  return (
    <div
      className="modal fade"
      id="existingtaskwarning"
      tabIndex="-1"
      aria-labelledby="existingtaskwarninglabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-body text-center px-4 py-5">
            <img
              src={assetImages.exclamationIcon}
              alt="warning"
              className="img-fluid"
            />
            <h2>{t("Hey! you already have a ongoing task")}</h2>
            <h3>
              **{" "}
              {t("You need to stop an ongoing task before continuing other.")}
            </h3>
            <div className="d-flex gap-3 justify-content-center">
              <Link
                to="#"
                className="btn btn-outline-primary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {t("Continue with ongoing task")}
              </Link>

              <button
                className="btn btn-primary"
                onClick={stopOngoingTaskHandler}
              >
                {t("Stop the ongoing task")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExistingTaskWarningModal;
